export type QueryParameters = { [key: string]: string | boolean };

export const querystringParamRegexp = /^([^=]+)(?:=(.*))?$/;
type QueryParamMatch = [
  string | undefined,
  string | undefined,
  string | undefined
];

export function parseQueryString(querystring: string): QueryParameters {
  const parameters: QueryParameters = {};

  const paramParts = querystring.replace(/^\?/, '').split('&');

  for (let paramPart of paramParts) {
    const [, key, value] = (paramPart.match(querystringParamRegexp) ||
      []) as QueryParamMatch;

    if (key) {
      parameters[key] = value === undefined ? true : decodeURIComponent(value);
    }
  }

  return parameters;
}



// WEBPACK FOOTER //
// ./src/app/utils/querystring.ts